import InfoPatientRight from '../../InfoPatientRight';
import ActionButton from './ActionButton';

type Props = {
	benhNhanInfo: any;
	onClose: () => void;
};

const Header = ({ benhNhanInfo, onClose }: Props) => {
	return (
		<div className="d-flex justify-content-between gap-6 w-100">
			<ActionButton onClose={onClose} />
			<InfoPatientRight benhNhanInfo={benhNhanInfo} />
		</div>
	);
};

export default Header;
